// MOCK DATA for inner pages (frontend only)

export const nav = [
  { label: "Home", to: "/" },
  {
    label: "About",
    to: "/about",
    children: [
      { label: "About the Academy", to: "/about" },
      { label: "Vision & Mission", to: "/about#vision" },
      { label: "Leadership", to: "/about#leadership" },
    ],
  },
  {
    label: "Academics",
    to: "/academics",
    children: [
      { label: "Curriculum Overview", to: "/academics" },
      { label: "Pre-KG to Upper KG", to: "/academics/pre-kg-upper-kg" },
      { label: "Grades 1 & 2", to: "/academics/grades-1-2" },
      { label: "Grades 3 to 7", to: "/academics/grades-3-7" },
    ],
  },
  {
    label: "Campus & Infrastructure",
    to: "/campus",
    children: [
      { label: "Campus & Infrastructure", to: "/campus" },
      { label: "Facilities", to: "/campus#infrastructure" },
      { label: "Life on Campus", to: "/campus#campus" },
    ],
  },
  {
    label: "Admissions",
    to: "/admissions",
    children: [
      { label: "Admission Process", to: "/admissions" },
      { label: "Downloads", to: "/downloads" },
      { label: "FAQs", to: "/faq" },
    ],
  },
  { label: "Contact", to: "/contact" },
];

export const leadership = [
  {
    name: "Dr. K.P. Ramasamy",
    role: "Chairman, KPR Group",
    image: "/leaders/kp-ramasamy.png",
    fallback: "/leaders/kp-ramasamy-alt.png",
    quote: "Think Bold, Learn Joyfully, Lead Responsibly.",
    bio: "Beyond being a very successful entrepreneur, the brilliance of a man is in contributing to the society from what he has earned. Hailing from an agricultural family, 'KPR' made a humble beginning as a power loom cloth manufacturer in 1971 and built the KPR Group on fabulous values. Understanding that the well-being of people is not restricted to physical wellness alone, he formulated an outstanding concept of empowering people with higher education besides providing trendsetting facilities.",
    link: "https://www.kprmilllimited.com/mr-k-p-ramasamy",
  },
  {
    name: "Ms. Gayathri Anandakrishnan",
    role: "Secretary, KPR Institutions",
    image: "/leaders/gayathri.png",
    fallback: "/leaders/gayathri.png",
    quote: "Every child deserves a campus that says yes to their curiosity.",
    bio: "As Secretary of the KPR Institutions, she leads the academic vision across the group's schools and colleges — championing joyful, inquiry-led learning, strong values and world-class infrastructure so that every learner at The KPR Academy grows academically, creatively and emotionally.",
    link: "https://www.kpriet.ac.in/coreteam",
  },
  {
    name: "Ms. Thara Mohan",
    role: "Chief Executive Officer, The KPR Academy",
    image: null,
    initials: "TM",
    quote: "A school is judged by what a child dares to try.",
    bio: "She leads the day-to-day life of the Academy — faculty development, curriculum delivery and parent partnership. Her focus is a campus where structure and joy exist together, and where every promise made to a parent is kept.",
    link: null,
  },
  {
    name: "Principal",
    role: "Principal, The KPR Academy",
    image: null,
    initials: "KA",
    quote: "Strong foundations, gently built.",
    bio: "Our Principal anchors academics, assessment and pastoral care across Pre-KG to Grade VII, working closely with CBSE-trained faculty. Appointment details and photograph will be updated shortly.",
    link: null,
  },
];

// The learning ecosystem KPR has built over five decades
export const ecosystem = {
  intro:
    "The KPR Academy does not start from zero. It inherits five decades of building places where people learn — a group that put its own employees through college long before it was fashionable, and now runs one of Coimbatore's largest education ecosystems.",
  milestones: [
    { year: "1971", title: "A humble beginning", text: "K.P. Ramasamy starts as a power loom cloth manufacturer, building the KPR Group on the value of giving back." },
    { year: "1990s", title: "Educating our own", text: "A trendsetting concept: empowering employees with higher education alongside housing, health and wellness on campus." },
    { year: "2009", title: "KPR Institute of Engineering & Technology", text: "An autonomous, NAAC-accredited engineering institution known for placements, research and innovation." },
    { year: "2019", title: "KPR College of Arts Science and Research", text: "Industry-linked UG and PG programmes across commerce, computing, management and the sciences." },
    { year: "Today", title: "10,500+ learners", text: "Schools, colleges and skilling centres across a 160+ acre education campus in Arasur, Coimbatore." },
    { year: "Now", title: "The KPR Academy", text: "A CBSE school that opens the same labs, arenas, faculty culture and values to children from Pre-KG onward." },
  ],
  advantages: [
    { icon: "FlaskConical", title: "College-grade labs, school-age learners", text: "Engineering and science infrastructure standards applied to a K-12 campus — not scaled-down versions." },
    { icon: "Users", title: "Faculty development culture", text: "Continuous internal training borrowed from a group that trains thousands of educators and staff every year." },
    { icon: "Route", title: "One campus, school to career", text: "A child can move from Pre-KG to engineering, arts, science or management inside the same trusted ecosystem." },
    { icon: "Handshake", title: "Growing by Giving", text: "Scholarship, service and community work are habits of the group, not a CSR line item." },
  ],
};

export const admissionSteps = [
  { no: "01", title: "Enquire", text: "Call the admission hotline or submit the enquiry form. Our team shares the age criteria, seat availability and fee details." },
  { no: "02", title: "Campus Visit", text: "Walk the campus with our team — classrooms, labs, library, arenas and the dining hall. Mon to Sat, 9:00 AM to 4:00 PM." },
  { no: "03", title: "Interaction", text: "An age-appropriate interaction or assessment helps us understand your child's learning level (where applicable)." },
  { no: "04", title: "Documentation", text: "Submit the application with the required documents and photographs." },
  { no: "05", title: "Confirmation", text: "On confirmation of the seat, complete the fee formalities and collect the joining kit and transport details." },
];

export const admissionDocs = [
  "Birth certificate (original + copy)",
  "Transfer Certificate (for applicable classes)",
  "Previous academic records / report cards",
  "Aadhaar copy of the student",
  "Aadhaar copy of both parents",
  "4 passport-size photographs of the student",
  "2 passport-size photographs of each parent",
  "Address proof and blood group record",
];

export const eligibility = [
  { grade: "Pre-KG", age: "2.5 years and above" },
  { grade: "LKG", age: "3.5 years and above" },
  { grade: "UKG", age: "4.5 years and above" },
  { grade: "Grade 1", age: "5.5 years and above" },
  { grade: "Grades 2 to 7", age: "As per CBSE norms with a valid TC" },
];

// Documents we can generate for the parent right now vs. those shared by the office
export const downloads = [
  {
    key: "enquiry-form",
    title: "Admission Enquiry Form",
    desc: "A print-ready enquiry form to fill in by hand and carry to your campus visit.",
    meta: "Print / Save as PDF",
    kind: "generate",
    icon: "FileText",
  },
  {
    key: "checklist",
    title: "Document Checklist",
    desc: "Everything to keep ready before the admission interaction, in one printable sheet.",
    meta: "Print / Save as PDF",
    kind: "generate",
    icon: "ListChecks",
  },
  {
    key: "prospectus",
    title: "School Prospectus 2026–27",
    desc: "The full prospectus with curriculum, facilities, timings and uniform details.",
    meta: "Shared by the admissions office",
    kind: "request",
    icon: "BookOpen",
  },
  {
    key: "fee",
    title: "Fee Structure",
    desc: "Grade-wise fee, transport charges and payment schedule for the academic year.",
    meta: "Shared on enquiry",
    kind: "request",
    icon: "ReceiptText",
  },
  {
    key: "calendar",
    title: "Academic Calendar",
    desc: "Term dates, holidays, PTM dates and examination schedule.",
    meta: "Shared with enrolled parents",
    kind: "request",
    icon: "CalendarDays",
  },
  {
    key: "transport",
    title: "Transport Routes",
    desc: "City-wide bus routes, pick-up points and approximate timings.",
    meta: "Shared on enquiry",
    kind: "request",
    icon: "Bus",
  },
  {
    key: "disclosure",
    title: "Mandatory Public Disclosure",
    desc: "CBSE mandatory disclosure documents and affiliation details.",
    meta: "Available at the school office",
    kind: "request",
    icon: "ShieldCheck",
  },
];

export const stages = {
  "pre-kg-upper-kg": {
    title: "Pre-KG to Upper KG",
    badge: "Foundational Stage",
    intro:
      "Learning is play-based and child-centric, focusing on building fine and gross motor skills through structured play, creative zones, outdoor movement, arts, music, storytelling and mindfulness in a safe, comfortable environment.",
    image:
      "https://images.unsplash.com/photo-1740710543611-80b658171bc3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxhcnQlMjByb29tfGVufDB8fHx8MTc4ODQyNDMyM3ww&ixlib=rb-4.1.0&q=85",
    highlights: [
      { title: "Structured play", text: "Purposeful play zones that build motor skills, sharing and early problem solving." },
      { title: "Expression first", text: "Yoga, dance, art, clay modeling and music are timetabled, not optional." },
      { title: "Indoor–outdoor rhythm", text: "Explorative play across sand, water, garden and movement areas every single day." },
      { title: "Mindful mornings", text: "Circle time, storytelling and breathing routines settle young learners into the day." },
    ],
    subjects: ["Early literacy", "Early numeracy", "Environment awareness", "Art & craft", "Music & movement", "Physical play"],
    assessment:
      "Observation-based, continuous and completely non-threatening — teachers document milestones and share them with parents through portfolios and conversations.",
  },
  "grades-1-2": {
    title: "Grades 1 & 2",
    badge: "Preparatory Stage",
    intro:
      "Teaching follows a structured CBSE continuous assessment system, combining formative and summative evaluations for holistic growth, with core subjects alongside physical education, performing arts and hands-on lab exposure.",
    image:
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxjbGFzc3Jvb218ZW58MHx8fHwxNzg4NDI0MzIzfDA&ixlib=rb-4.1.0&q=85",
    highlights: [
      { title: "Strong foundations", text: "English, Mathematics, EVS and Language taught with concrete-to-abstract progression." },
      { title: "Labs from year one", text: "Coding & AI lab exposure and library periods built into the weekly timetable." },
      { title: "Performing arts", text: "Music, dance and theatre sessions with dedicated faculty and stage exposure." },
      { title: "Physical literacy", text: "Daily PE, swim lessons and multi-sport introduction for every learner." },
    ],
    subjects: ["English", "Mathematics", "EVS", "Second Language", "Computer & AI basics", "Physical Education", "Performing Arts"],
    assessment:
      "CBSE continuous assessment — periodic tests, subject enrichment activities, portfolio and multiple assessments feeding into a term report.",
  },
  "grades-3-7": {
    title: "Grades 3 to 7",
    badge: "Middle Stage",
    intro:
      "Learning is driven by project-based and experiential methods, supported by subject enrichment activities and continuous, competency-based evaluation. The curriculum integrates co-scholastic assessment and aligns with the Sustainable Development Goals.",
    image:
      "https://images.unsplash.com/photo-1532186773960-85649e5cb70b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxyb2JvdGljcyUyMGxhYnxlbnwwfHx8fDE3ODg0MjQzMjl8MA&ixlib=rb-4.1.0&q=85",
    highlights: [
      { title: "Project-based learning", text: "Field trips, exhibitions and real-world projects anchor every unit of study." },
      { title: "Student Led Conferences", text: "Children present their own learning journey to parents — ownership over marks." },
      { title: "SDG aligned", text: "Co-scholastic work maps to the Sustainable Development Goals and community service." },
      { title: "Specialise in sport", text: "From Grade VI learners choose a sport and train for district, state and national meets." },
    ],
    subjects: ["English", "Mathematics", "Science", "Social Science", "Second & Third Language", "Computer Science / AI", "Art Education", "Health & Physical Education"],
    assessment:
      "Competency-based and continuous — periodic tests, term examinations, portfolio, subject enrichment and co-scholastic grading as per CBSE.",
  },
};

export const faqsFull = [
  { q: "Which classes are offered at The KPR Academy?", a: "The school offers classes from foundational levels up to senior secondary levels, as per CBSE norms. Admissions are currently open from Pre-KG through Grade VII." },
  { q: "What curriculum does the school follow?", a: "The school follows the CBSE curriculum with a strong focus on academics, life skills, values and holistic development." },
  { q: "What is the admission process?", a: "Admissions are based on availability of seats, age eligibility, interaction/assessment (if applicable), and submission of required documents." },
  { q: "What documents are required for admission?", a: "Birth certificate, Transfer Certificate (for applicable classes), previous academic records, Aadhaar copy, and passport-size photographs." },
  { q: "Is there an entrance test for admission?", a: "An age-appropriate assessment or interaction may be conducted for certain classes to understand the student's learning level." },
  { q: "What is the medium of instruction?", a: "English is the primary medium of instruction, in line with CBSE standards." },
  { q: "What are the school timings?", a: "School timings will be communicated to parents at the beginning of the academic year." },
  { q: "Does the school provide transport facilities?", a: "Yes, transport facilities are available on selected routes, subject to availability and safety norms." },
  { q: "What is the student–teacher ratio?", a: "The school maintains an optimal student–teacher ratio to ensure individual attention and effective learning." },
  { q: "How are students assessed?", a: "Assessment follows the CBSE pattern, including periodic tests, internal assessments, projects and examinations." },
  { q: "Does the school follow Continuous and Comprehensive Evaluation?", a: "Yes, evaluation is continuous and includes both scholastic and co-scholastic development." },
  { q: "Are extracurricular activities encouraged?", a: "Yes, the school promotes sports, arts, cultural activities, clubs and value-based programs as part of holistic education." },
  { q: "What facilities are available on campus?", a: "The campus includes well-equipped classrooms, laboratories, library, sports facilities and activity spaces across 160+ acres." },
  { q: "How does the school ensure student safety?", a: "Student safety is ensured through trained staff, CCTV surveillance, disciplined procedures and a secure campus environment." },
  { q: "Are teachers CBSE-trained and qualified?", a: "Yes, all faculty members are qualified, experienced and trained as per CBSE requirements, with regular professional development." },
  { q: "How does the school communicate with parents?", a: "Through Parent-Teacher Meetings, the school diary / ERP portal, circulars and notices by email, official website updates and the parent app." },
  { q: "Does the school provide counselling support?", a: "Yes, academic and personal counselling support is available to guide students and parents when required." },
  { q: "What is the fee payment structure?", a: "Fee details, payment schedules and policies are shared transparently during the admission process." },
  { q: "What is Comprehensive Evaluation?", a: "A CBSE-mandated system that assesses academic performance as well as overall development, including life skills, attitudes and participation in activities." },
  { q: "How is academic performance evaluated?", a: "Through periodic tests and term exams, subject enrichment activities, portfolio assessment and multiple assessments." },
  { q: "What are co-scholastic areas?", a: "Life skills, discipline and values, health and physical education, and participation in sports, arts and cultural activities." },
  { q: "How are students informed about their performance?", a: "Through report cards, Parent-Teacher Meetings and continuous feedback from teachers." },
  { q: "How can parents contact the school?", a: "Call the admission hotlines, message us on WhatsApp, or visit the school office at the Arasur campus." },
];

export const campusMoments = [
  { title: "Student Led Conferences", text: "Children walk parents through their own portfolio, targets and reflections." },
  { title: "House system & assemblies", text: "Weekly assemblies, house competitions and student council responsibilities." },
  { title: "Festivals & culture", text: "Pongal, Onam, Diwali, Christmas and Independence Day celebrated on campus." },
  { title: "Clubs", text: "Robotics, eco, quiz, culinary, theatre, pottery and reading clubs every week." },
  { title: "Field learning", text: "Trips, exhibitions and community service that take learning off the campus." },
  { title: "Wellness", text: "Yoga, counselling, infirmary support and mindful movement built into the week." },
];
